const maintenanceCardLabel = {
  description: 'Description',
  value: 'Value',
  company: 'Company',
  sendToMaintenanceDate: 'Expected Date to Send for Maintenance',
  returnFromMaintenanceDate: 'Expected Maintenance Return Date',
  warranty: 'Warranty Deadline',
  expiration: 'Expiration date',
};

export default maintenanceCardLabel;